import AquaaActionTypes from "../../constants/Applications/aquaa-actionTypes";

export const saveEvaluationData = (data) => ({
    type: AquaaActionTypes.SAVE_EVALUATION_DATA,
    payload: data
});


export const getAquaaAccountsData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ACCOUNTS_DATA
  });

export const getAquaaAgentsData = (account,location,channel) => ({
    type: AquaaActionTypes.GET_AQUAA_AGENTS_DATA,
    account: account,
    location:location,
    channel:channel
  });

export const getAquaaChannelsData = (account,location) => ({
    type: AquaaActionTypes.GET_AQUAA_CHANNELS_DATA,
    account: account,
    location: location
  });

export const getAquaaLanguagesData = (account,agent,channel,location) => ({
    type: AquaaActionTypes.GET_AQUAA_LANGUAGES_DATA,
    account: account,
    agent: agent,
    channel: channel,
    location:location
  });

export const getAquaaLocationsData = (account) => ({
    type: AquaaActionTypes.GET_AQUAA_LOCATIONS_DATA,
    account: account,
    
  });

  export const getAquaaValidFromData = () => ({
    type: AquaaActionTypes.GET_AQUAA_VALIDFROM_DATA,
  });

  export const getAquaaAWSData = (account,agent,channel,language,location,from,to) => ({
    type: AquaaActionTypes.GET_AQUAA_AWS_DATA,
    account: account,
    agent: agent,
    channel: channel,
    language:language,
    location:location,
    from:from,
    to:to
  });

  export const getEvaluationFormData = (contactId,contactFormID,countryID) => ({
    type: AquaaActionTypes.GET_EVALUATION_FORM_DATA,
    contactId:contactId,
    contactFormID:contactFormID,
    countryID:countryID
  });

  export const  updateEvaluationFormDataStart= (data) => (
      {
        type: AquaaActionTypes.UPDATE_EVALUATION_FORM_DATA_START,
        payload: data,
      }
    )
    
    export const updateEvaluationFormDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_EVALUATION_FORM_DATA_SUCCESS,
      }
    )

    export const getSavedEvaluationsData = () => ({
      type: AquaaActionTypes.GET_SAVED_EVALUATIONS_DATA
    });

    export const getSubmittedEvaluationsData = () => ({
      type: AquaaActionTypes.GET_SUBMITTED_EVALUATIONS_DATA
    });

    export const getSavedEvaluationFormData = (evaluationId) => ({
      type: AquaaActionTypes.GET_SAVED_EVALUATION_FORM_DATA,
      evaluationId:evaluationId
    });

    export const getAquaaNonASDAccountsData = () => ({
      type: AquaaActionTypes.GET_AQUAA_NONASD_ACCOUNTS_DATA
    });

    export const getAquaaNonASDChannelsData = (account,location) => ({
      type: AquaaActionTypes.GET_AQUAA_NONASD_CHANNELS_DATA,
      account: account,
      location:location
    });

    export const getAquaaNonASDLocationsData = (account) => ({
      type: AquaaActionTypes.GET_AQUAA_NONASD_LOCATIONS_DATA,
      account: account,
    });

    export const getAquaaNonASDLanguagesData = (account,location) => ({
      type: AquaaActionTypes.GET_AQUAA_NONASD_LANGUAGES_DATA,
      account: account,
      location:location
    });

    export const getAquaaNonASDAgentsData = (email) => ({
      type: AquaaActionTypes.GET_AQUAA_NONASD_AGENTS_DATA,
      email: email
    });

    export const getAdditionalReciepientsData = (email) => ({
      type: AquaaActionTypes.GET_ADDITIONAL_RECIPIENTS,
      email: email
    });

    export const getNonASDEvaluationFormData = (account,agent,channel,language,location,contactTypeID) => ({
      type: AquaaActionTypes.GET_NONASD_EVALUATION_FORM_DATA,
      account:account,
      agent:agent,
      channel:channel,
      language:language,
      location:location,
      contactTypeID:contactTypeID
    });

    export const getAgentEvaluationsData = () => ({
      type: AquaaActionTypes.GET_AGENT_EVALUATIONS_DATA
    });

    export const getAquaaAdminAccountsData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_DATA
    });

    export const getAquaaAdminAccountsTableData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA
    });

    export const getAquaaAdminChannelsData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ADMIN_CHANNELS_DATA
    });

    export const getAquaaAdminContactTypeTableData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA
    });

    export const updateAquaaAdminAccountsDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaAdminAccountsDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_ACCOUNT_DATA_SUCCESS,
      }
    )

    export const updateAquaaAdminContactTypeDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaAdminContactTypeDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_SUCCESS,
      }
    )

    export const getAquaaQuestionAssessmentsData = () => ({
    type: AquaaActionTypes.GET_AQUAA_QUESTION_ASSESSMENTS_DATA
    });

    export const getAquaaAdminQuestionsTableData = () => ({
    type: AquaaActionTypes.GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA
    });

    export const updateAquaaAdminQuestionsDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaAdminQuestionsDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ADMIN_QUESTIONS_DATA_SUCCESS,
      }
    )

    export const updateAquaaAcknowledgementDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaAcknowledgementDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA_SUCCESS,
      }
    )

    export const getAquaaMappingAccounts = () => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_ACCOUNTS,
    });

    export const getAquaaMappingContacttypeForms = () => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_CONTACTTYPE_FORMS,
    });

    export const getAquaaMappingCountries = (account) => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_COUNTRIES,
      account:account
    });

    export const getAquaaMappingSections = () => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_SECTIONS,
    });

    export const getAquaaMappingQuestions = (question) => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_QUESTIONS,
      question:question
    });

    export const getAquaaMappingParameterType = () => ({
      type: AquaaActionTypes.GET_AQUAA_MAPPING_PARAMETERTYPE,
    });

    export const updateAquaaMappingDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_MAPPING_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaMappingDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_MAPPING_DATA_SUCCESS,
      }
    )

    export const getAquaaEvaluationsDelete = (parameter,value,roleid) => ({
      type: AquaaActionTypes.GET_AQUAA_EVALUATIONS_DELETE,
      parameter:parameter,
      value:value,
      roleid:roleid
    });

    export const updateAquaaEvaluationsDeleteStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_EVALUATIONS_DELETE_START,
        payload: data,
      }
    )
    
    export const updateAquaaEvaluationsDeleteSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_EVALUATIONS_DELETE_SUCCESS,
      }
    )

    export const getAquaaValidateTicketNo = (ticketNo) => ({
      type: AquaaActionTypes.GET_AQUAA_VALIDATE_TICKET_NO,
      ticketNo:ticketNo
    });

    export const getAquaaIcedAgents = () => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_AGENTS,
    });

    export const getAquaaIcedAccounts = () => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_ACCOUNTS,
    });

    export const getAquaaIcedTableData = (StartDT,EndDT,Agent,Account,TicketNumber) => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_TABLE_DATA,
      StartDT:StartDT,
      EndDT:EndDT,
      Agent:Agent,
      Account:Account,
      TicketNumber:TicketNumber
    });

    export const getAquaaIcedL1Category = () => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_L1_CATEGORY,
    });

    export const getAquaaIcedL2Category = () => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_L2_CATEGORY,
    });

    export const updateAquaaIcedDataStart = (data) => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ICED_DATA_START,
        payload: data,
      }
    )
    
    export const updateAquaaIcedDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AQUAA_ICED_DATA_SUCCESS,
      }
    )

    export const getAquaaIcedEvaluationsData = (roleId) => ({
      type: AquaaActionTypes.GET_AQUAA_ICED_EVALUATIONS_DATA,
      roleId:roleId
    });

    export const getAccountEvaluatorAccountsData = (roleId) => ({
      type: AquaaActionTypes.GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA,
      roleId:roleId
    });

    export const getAccountEvaluatorEvaluatorsData = (roleId) => ({
      type: AquaaActionTypes.GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA,
      roleId:roleId
    });

    export const getAccountEvaluatorTableData = (accountId,evaluatorId,roleId) => ({
      type: AquaaActionTypes.GET_ACCOUNT_EVALUATOR_TABLE_DATA,
      accountId:accountId,
      evaluatorId:evaluatorId,
      roleId:roleId
    });

    export const updateAccountEvaluatorMappingDataStart = (data, callback) => (
      {
        type: AquaaActionTypes.UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateAccountEvaluatorMappingDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA_SUCCESS,
      }
    )

    export const updateNewEvaluatorDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_NEW_EVALUATOR_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateNewEvaluatorDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_NEW_EVALUATOR_DATA_SUCCESS,
      }
    )

    export const getAccountEvaluatorUsersData = (agent) => ({
      type: AquaaActionTypes.GET_ACCOUNT_EVALUATOR_USERS_DATA,
      agent:agent
    });

    export const getIcedReportsAccountsData = (roleId) => ({
      type: AquaaActionTypes.GET_ICED_REPORTS_ACCOUNTS,
      roleId:roleId
    });

     export const getIcedMasterData = (roleId) => ({
      type: AquaaActionTypes.GET_ICED_MASTER_DATA,
      roleId:roleId
    });

    export const updateIcedDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_ICED_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateIcedDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_ICED_DATA_SUCCESS,
      }
    )

    export const getIcedTableData = () => ({
      type: AquaaActionTypes.GET_ICED_TABLE_DATA,
    });

    export const updateSubmittedCommentsDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_SUBMITTED_COMMENTS_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateSubmittedCommentsDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_SUBMITTED_COMMENTS_DATA_SUCCESS,
      }
    )

    export const getRecommendationsTableData = (Recommendation,Status,AssignedToMe) => ({
      type: AquaaActionTypes.GET_RECOMMENDATIONS_TABLE_DATA,
      Recommendation:Recommendation,
      Status:Status,
      AssignedToMe:AssignedToMe
    });

    export const updateTrainingAssignmentDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_TRAINING_ASSIGNMENT_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateTrainingAssignmentDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_TRAINING_ASSIGNMENT_DATA_SUCCESS,
      }
    )

    export const updateTrainingCommentsDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_TRAINING_COMMENTS_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateTrainingCommentsDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_TRAINING_COMMENTS_DATA_SUCCESS,
      }
    )

    export const getTrainerTableData = () => ({
      type: AquaaActionTypes.GET_TRAINER_TABLE_DATA,
    });

    export const updateAgentTrainingCommentsDataStart = (data,callback) => (
      {
        type: AquaaActionTypes.UPDATE_AGENT_TRAINING_COMMENTS_DATA_START,
        payload: data,
        callback
      }
    )
    
    export const updateAgentTrainingCommentsDataSuccess = () => (
      {
        type: AquaaActionTypes.UPDATE_AGENT_TRAINING_COMMENTS_DATA_SUCCESS,
      }
    )

    export const getRecommendationsDropdownData = () => ({
      type: AquaaActionTypes.GET_RECOMMENDATIONS_DROPDOWN_DATA,
      
    });